import { selector } from "recoil";
import { Paths } from "src/navigation";
import { Address, Carousel, Document, Faq, Insured, Optional, ProductInfo } from "src/types";

import {
  atomDossier,
  atomOfficesDossier,
  atomPolicy,
  atomSelectedProduct,
  pathAtom,
} from "./data.atoms";

export const selectorDossierHasProducts = selector<boolean>({
  key: "dossierHasProducts",
  get: ({ get }) => {
    const dossier = get(atomDossier);
    return (
      !!dossier?.codProd && dossier?.prodotti && dossier?.prodotti.length > 0
    );
  },
});

export const selectorFaqs = selector<Optional<Faq[]>>({
  key: "faq",
  get: ({ get }) => get(atomSelectedProduct)?.faq,
});

export const selectorDocuments = selector<Optional<Document[]>>({
  key: "documents",
  get: ({ get }) => {
    return get(atomSelectedProduct)?.documenti?.filter((doc) =>
      doc.docCode.startsWith("DOC")
    );
  },
});

export const selectorFooterDocuments = selector<Optional<Document[]>>({
  key: "footerDocuments",
  get: ({ get }) =>
    get(atomSelectedProduct)?.documenti?.filter((doc) =>
      doc.docCode.startsWith("FOOTER")
    ),
});

export const selectorConsentDocuments = selector<Optional<Document[]>>({
  key: "consentDocuments",
  get: ({ get }) =>
    get(atomSelectedProduct)?.documenti?.filter((doc) =>
      doc.docCode.startsWith("CONS")
    ),
});

export const selectorCarousel = selector<Optional<Carousel[]>>({
  key: "carousel",
  get: ({ get }) => {
    const path = get(pathAtom);
    const selectedProduct = get(atomSelectedProduct);
    const dossier = get(atomDossier);

    if (path.includes("prodotti/") && selectedProduct) {
      return selectedProduct.carousel;
    }

    return dossier?.carousel;
  },
});

export const selectorDossierInsured = selector<Optional<Insured>>({
  key: "dossierInsured",
  get: ({ get }) => get(atomDossier)?.assicurato,
});

export const selectorInsured = selector<Optional<Insured>>({
  key: "insured",
  get: ({ get }) => get(atomPolicy)?.assicurato,
});

export const selectorInsuredOfficesStudios = selector<Optional<Insured>>({
  key: "insuredOfficesStudios",
  get: ({ get }) => get(atomDossier)?.assicurato,
  set: ({ set, get }, newValue) => {
    const currentDossier = get(atomDossier);
    if (currentDossier) {
      set(atomDossier, {
        ...currentDossier,
        assicurato: newValue as Optional<Insured>,
      });
    }
  },
});

export const selectorAddress = selector<Optional<Address>>({
  key: "office",
  get: ({ get }) => get(atomPolicy)?.sede,
});

export const selectorProduct = selector<ProductInfo>({
  key: "product",
  get: ({ get }) => get(atomSelectedProduct)?.prodotto,
});